import React, { useState, useEffect, useContext } from "react";
import { MDBDatatable, MDBTable, MDBTableHead, MDBTableBody, MDBIcon, MDBBtn, MDBSelect } from "mdb-react-ui-kit";
import { AppContext } from "../../AppContextProvider";
import DeleteModal from "../../modals/DeleteModal";
import { WarningTicket, NotificationsTicket } from "../../components/TicketsComponent";
import UseraddressJsonStorage from "../../utils/useraddress/useraddressJsonStorage";
import { AvalancheContext } from "../../avalanche/AvalancheProvider";
import { useWalletProvider } from "../../walletprovider/useWalletProvider";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import {
  collectLog,
  createEmptyLogsAndVars,
  dwReportError,
  recordVariable,
} from "../../utils/diagnostics/clientErrors";
import filter_alt from "../../assets/media/icons/filter-alt.svg";
import delete_icon from "../../assets/media/icons/delete.svg";
import cross_invert from "../../assets/media/icons/cross-invert.svg";
import tag from "../../assets/media/icons/tag.svg";
import cross_invert_color from "../../assets/media/icons/cross-invert-color.svg";
import tag_color from "../../assets/media/icons/tag-color.svg";

export default function TableComponent(props) {
  const context = useContext(AppContext);
  const avalancheContext = useContext(AvalancheContext);
  const useraddressJsonStorage = UseraddressJsonStorage.create(avalancheContext);
  const { selectedAccount } = useWalletProvider();
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const [feedbackId, setFeedbackId] = useState();
  const [feedbackArray, setFeedbackArray] = useState([]);
  const [isMultiselect, setIsMultiselect] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isWarningTicket, setIsWarningTicket] = useState(false);
  const [isDoneTicket, setIsDoneTicket] = useState(false);
  const [activeNumber, setActiveNumber] = useState(1);
  const [data, setData] = useState([]);
  const [filterArray, setFilterArray] = useState([]);
  const [activeDate, setActiveDate] = useState(
    props.feedbackArray.filter((k) => k.feedback.date !== "")[0].feedback.date,
  );

  const getWhiteUserList = async () => {
    const logsAndVars = createEmptyLogsAndVars("TableComponent:getWhiteUserList");
    try {
      const res = await useraddressJsonStorage.getAllUserAddress();
      recordVariable(logsAndVars, "getAllUserAddress result", res);
      for (let i = 0; i < props.feedbackArray.length; i++) {
        props.feedbackArray[i].feedbackId = i;
        props.feedbackArray[i].role = res
          .filter((k) => k.address === props.feedbackArray[i].address)
          .map((k) => {
            return k.useraddress.role;
          })[0];
      }
      recordVariable(logsAndVars, "processed props.feedbackArray", props.feedbackArray);
      setFeedbackArray(props.feedbackArray);
      let setToArrayFinal = [];
      let array = props.feedbackArray.map((k) => {
        return k.role;
      });
      var set = new Set(array);
      const setToArray = Array.from(set);
      recordVariable(logsAndVars, "roles set", setToArray);
      for (let i = 0; i < setToArray.length; i++) {
        setToArrayFinal.push({ text: setToArray[i] });
      }
      setData(setToArrayFinal);
      setFilterArray(setToArray);
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      console.log(error);
    }
  };

  useEffect(() => {
    getWhiteUserList();
  }, [context.getState()?.isRender]);

  const actionData = {
    columns:
      window.location.pathname === "/admin"
        ? [
            { label: "Nr.", field: "number" },
            { label: "Date", field: "date" },
            {
              label: (
                <div className="d-flex align-items-center justify-content-center">
                  <span>{"Role"}</span>
                </div>
              ),
              field: "role",
            },
            { label: "Delete", field: "delete", sort: false },
          ]
        : [
            { label: "Nr.", field: "number" },
            { label: "Date", field: "date" },
            { label: "Delete", field: "delete", sort: false },
          ],
    rows: feedbackArray
      .filter((k) => k.feedback.date !== "")
      .filter((k) => filterArray.includes(k.role))
      .map((k, n) => {
        return {
          number: n + 1,
          date: k.feedback.date,
          role: k.role,
          unread: k.feedback.isUnread,
          feedbackId: k.feedbackId,
        };
      })
      .map((row, i) => {
        if (window.location.pathname === "/admin") {
          return {
            ...row,
            number: (
              <div
                className={
                  row.unread
                    ? activeNumber === row.feedbackId + 1
                      ? "table-row-number active unread"
                      : "table-row-number unread"
                    : activeNumber === row.feedbackId + 1
                      ? "table-row-number active"
                      : "table-row-number"
                }
                onClick={() => {
                  setActiveNumber(row.feedbackId + 1);
                  props.setFeedbackId(row.feedbackId, false);
                }}
              >
                <span>{row.number}</span>
              </div>
            ),
            date: (
              <div
                className={
                  row.unread
                    ? activeNumber === row.feedbackId + 1
                      ? "table-row-date active unread"
                      : "table-row-date unread"
                    : activeNumber === row.feedbackId + 1
                      ? "table-row-date active"
                      : "table-row-date"
                }
                onClick={() => {
                  setActiveNumber(row.feedbackId + 1);
                  props.setFeedbackId(row.feedbackId, false);
                }}
              >
                <span>{row.date}</span>
              </div>
            ),
            role: (
              <div
                className={
                  row.unread
                    ? activeNumber === row.feedbackId + 1
                      ? "table-row-date active unread role"
                      : "table-row-date unread role"
                    : activeNumber === row.feedbackId + 1
                      ? "table-row-date active role"
                      : "table-row-date role"
                }
                onClick={() => {
                  setActiveNumber(row.feedbackId + 1);
                  props.setFeedbackId(row.feedbackId, false);
                }}
              >
                <span>{row.role}</span>
              </div>
            ),

            delete: (
              <>
                <button
                  className="button subtle medium"
                  onClick={() => {
                    setFeedbackId(row.feedbackId);
                    //setOpenModal(true);
                    setIsWarningTicket(true);
                  }}
                >
                  <MDBIcon far icon="trash-alt" />
                </button>
              </>
            ),
          };
        } else {
          return {
            ...row,
            number: (
              <div
                className={
                  row.unread
                    ? activeNumber === row.feedbackId + 1
                      ? "table-row-number active unread"
                      : "table-row-number unread"
                    : activeNumber === row.feedbackId + 1
                      ? "table-row-number active"
                      : "table-row-number"
                }
                onClick={() => {
                  setActiveNumber(row.feedbackId + 1);
                  props.setFeedbackId(row.feedbackId, false);
                }}
              >
                <span>{row.number}</span>
              </div>
            ),
            date: (
              <div
                className={
                  row.unread
                    ? activeNumber === row.feedbackId + 1
                      ? "table-row-date active unread"
                      : "table-row-date unread"
                    : activeNumber === row.feedbackId + 1
                      ? "table-row-date active"
                      : "table-row-date"
                }
                onClick={() => {
                  setActiveNumber(row.feedbackId + 1);
                  props.setFeedbackId(row.feedbackId, false);
                }}
              >
                <span>{row.date}</span>
              </div>
            ),

            delete: (
              <>
                <button
                  className="button subtle medium"
                  onClick={() => {
                    setFeedbackId(row.feedbackId);
                    //setOpenModal(true);
                    setIsWarningTicket(true);
                  }}
                >
                  <MDBIcon far icon="trash-alt" />
                </button>
              </>
            ),
          };
        }
      }),
  };
  return (
    <>
      {window.location.pathname === "/admin" && data.length > 0 && (
        <>
          <div className="actions-div ms-2">
            <MDBSelect
              data={data}
              multiple
              clearBtn={isMultiselect}
              onValueChange={(val) =>
                setFilterArray(
                  val.length > 0
                    ? val.map((k) => {
                        setIsMultiselect(true);
                        return k.text;
                      })
                    : data.map((k) => {
                        setIsMultiselect(false);
                        return k.text;
                      }),
                )
              }
              label={
                <div className="multiselect-div">
                  <img src={filter_alt} alt="filter" />
                  <span>Filter</span>
                </div>
              }
            />
            {window.innerWidth > 992 && <div className="spacer" />}
            {isMultiselect && (
              <>
                <div className="filter-div">
                  <span className="filter-title">Filter:</span>
                  {filterArray.map((k, n) => {
                    return (
                      <div className="tags-div-2" key={n}>
                        <img src={tag_color} alt="tag" />
                        <span>{k}</span>
                        <img src={cross_invert_color} alt="cross-invert" />
                      </div>
                    );
                  })}
                </div>
                {window.innerWidth > 992 && <div className="spacer" />}
              </>
            )}
          </div>
        </>
      )}
      <MDBDatatable hover data={actionData} />
      <div className="ticket-div">
        {isDoneTicket && (
          <>
            <NotificationsTicket
              close={() => {
                setIsDoneTicket(false);
                context.onSetIsRender();
              }}
              text={"Deleted sucessfully!"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isWarningTicket && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicket(false);
              }}
              text={"Are you sure that you want to delete the feedback?"}
              actionsButton={true}
              onDelete={() => {
                props.setFeedbackId(feedbackId, true);
                setIsWarningTicket(false);
                setIsDoneTicket(true);
              }}
              buttonText={"Delete"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>
      {openModal && (
        <DeleteModal
          visible={openModal}
          handleClose={() => setOpenModal(false)}
          onDeleteFeedback={() => {
            props.setFeedbackId(feedbackId, true);
            setOpenModal(false);
          }}
        />
      )}
    </>
  );
}
